import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, isAdmin, userType } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if trying to access admin routes
  if (location.pathname.startsWith('/admin')) {
    if (!isAdmin) {
      // Redirect non-admin users to their appropriate dashboard
      return <Navigate to={userType === 'client' ? '/client' : '/user'} replace />;
    }
  }

  // Check if trying to access client routes
  if (location.pathname.startsWith('/client')) {
    if (isAdmin) {
      // Redirect admin users to admin dashboard
      return <Navigate to="/admin" replace />;
    }
    if (userType === 'user') {
      // Redirect regular users to user page
      return <Navigate to="/user" replace />;
    }
  }

  // Check if trying to access user routes
  if (location.pathname.startsWith('/user')) {
    if (isAdmin || userType === 'client') {
      // Redirect admin and client users to their appropriate dashboard
      return <Navigate to={isAdmin ? '/admin' : '/client'} replace />;
    }
  }

  // Redirect root path to appropriate dashboard
  if (location.pathname === '/') {
    if (isAdmin) {
      return <Navigate to="/admin" replace />;
    } else if (userType === 'client') {
      return <Navigate to="/client" replace />;
    } else {
      return <Navigate to="/user" replace />;
    }
  }

  return children;
};

export default PrivateRoute; 